<h2 mat-dialog-title>
    Select A Declined Reason</h2>
  <mat-dialog-content class="flex flex-col">
    <mat-radio-group [(ngModel)]="selectedDeclinedReason" class="flex flex-col">
      <mat-radio-button class="flex flex-row place-content-between place-items-center m-3 text-gray-700" *ngFor="let declinedReason of data.declinedReasons | orderBy: 'reason'"
        [value]="declinedReason">
        <span>{{declinedReason.reason}}</span>
      </mat-radio-button>
    </mat-radio-group>
  </mat-dialog-content>
  <div mat-dialog-actions class="flex flex-row place-content-end place-items-end -mr-2 pb-2">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-button color="primary" (click)="onConfirm(selectedDeclinedReason)" [disabled]="!selectedDeclinedReason">Select</button>
  </div>